import { render, staticRenderFns } from "./WidgetFrenchTiers.vue?vue&type=template&id=8bc13080&"
import script from "./WidgetFrenchTiers.vue?vue&type=script&lang=js&"
export * from "./WidgetFrenchTiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports